import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 teres-alert bg-lightblue my-3",
  role: "alert"
}
const _hoisted_2 = {
  key: 0,
  class: "row list-unstyled my-3 mx-auto p-inline-start-0"
}
const _hoisted_3 = { class: "d-flex row reservation-overview no-underline" }
const _hoisted_4 = { class: "col-12 col-md-3 p-2 px-4 bg-darker bg-hover-dark font-weight-bold d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "col-12 col-md-9 d-flex align-items-center flex-md-row flex-column" }
const _hoisted_7 = { class: "saal-desc p-2" }
const _hoisted_8 = { class: "m-0" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { class: "ml-auto mb-2 mb-md-0" }
const _hoisted_11 = {
  key: 1,
  class: "col-12 teres-alert bg-lightblue my-3"
}
const _hoisted_12 = {
  key: 2,
  class: "col-12 teres-alert bg-lightblue my-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_link_arrow = _resolveComponent("link-arrow")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.reservationConfirmation.title')), 1),
    (_ctx.deletedFeedback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_feedback_message, {
            message: _ctx.$t('views.reservationConfirmation.success')
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      i18nErrorMessage: "views.reservationConfirmation.errorMessage"
    }, {
      default: _withCtx(() => [
        (_ctx.tickets.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'ticket-' + index,
                  class: "col-12 mb-3"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createTextVNode(_toDisplayString(_ctx.formatDay(ticket)), 1),
                      _hoisted_5,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatTimeOnly(ticket)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(ticket.roomName), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(ticket.roomDescription), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.isRemoveable(ticket))
                          ? (_openBlock(), _createBlock(_component_button_cancel, {
                              key: 0,
                              onClicked: ($event: any) => (_ctx.removeTicket(ticket)),
                              i18nMessage: _ctx.$t('views.reservationConfirmation.cancel'),
                              class: "btn-outline-icon-only btn-outline-icon-text-red"
                            }, null, 8, ["onClicked", "i18nMessage"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.tickets.length === 0 && _ctx.deletedFeedback)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_feedback_message, {
                message: _ctx.$t('views.reservationConfirmation.noTickets')
              }, null, 8, ["message"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tickets.length === 0 && _ctx.invalidOwnerId && _ctx.deletedFeedback === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_feedback_message, {
                message: _ctx.$tc('views.reservationConfirmation.invalidOwnerId', { msg: _ctx.ownerId })
              }, null, 8, ["message"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_link_arrow, {
          i18nMessage: "views.reservationConfirmation.newReservation",
          to: "/"
        })
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}